import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterWrapper from '#component/general/list-filter/filter-wrapper';
import MobileDoubleButtons from '#component/general/mobile-double-buttons/mobile-double-buttons';
import MobileTabs from '#component/general/mobile-tabs/mobile-tabs';
import { changePage, fetchWarehousesAndAppliances } from '#action/warehouse/warehouses';
import MobileDrawerMenu from '#component/general/mobile-drawer-menu';
import DeleteWarehouseDialog from '#component/addressbook/dashboard/delete-addressbook-dialog';
import { deleteWarehouse } from '#action/warehouse/warehouse';
import SitesTabContent from '#component/warehouse/cards-view/mobile-tabs/sites-tab-content';
import PreloaderComponent from '#component/preloader';
import warehouseFilterConfig from './warehouse-filter/config';
import {
  Root,
  NoFilterData,
  FilterButtonContainerSiteManager,
  TabsSpacing
} from './styles';

const SitesMobileView = ({
  applianceStatus,
  isFilterSelected,
  page,
  userType,
  paginatedWarehousesWithAppliances
}) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const [init, setInit] = useState(false);
  const [isDeleteSiteModalOpen, setIsDeleteSiteModalOpen] = useState(false);
  const [selectedSite, setSelectedSite] = useState(null);
  const [isSitesDrawerMenuOpen, setIsSitesDrawerMenuOpen] = useState(false);
  const {
    pages: sitePages,
    status: sitesStatus
  } = useSelector(state => state.warehousesPaginated, shallowEqual);
  const loading = applianceStatus !== 'succeeded' || applianceStatus === 'idle';
  const sitesLoading = ['loading', 'idle'].includes(sitesStatus) || !init;

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchWarehousesAndAppliances(true));

      setInit(true);
    };

    fetchData();
  }, [dispatch]);

  const tabLabels = ['Appliances', 'Sites'];

  const handleSitesDrawerMenuOpen = () => {
    setIsSitesDrawerMenuOpen(true);
  };

  const handleSitesDrawerMenuClose = () => {
    setIsSitesDrawerMenuOpen(false);
    setSelectedSite(null);
  };

  const handleDeleteSiteModalClose = () => {
    setIsDeleteSiteModalOpen(false);
    setIsSitesDrawerMenuOpen(null);
    setSelectedSite(null);
  };

  const handleDeleteSite = async () => {
    const result = await dispatch(deleteWarehouse(selectedSite?.id));
    if (result?.success) {
      handleDeleteSiteModalClose();
      dispatch(fetchWarehousesAndAppliances());
    }
  };

  const handleSiteEdit = () => history.push(`/warehouse/edit/${selectedSite?.id}`);
  const handleSiteDelete = () => setIsDeleteSiteModalOpen(true);

  const emptySitesMenuItems = [
    { name: 'Edit', onClick: handleSiteEdit, icon: <EditIcon /> },
    { name: 'Delete', onClick: handleSiteDelete, icon: <DeleteIcon /> }
  ];

  const handleSitePageChange = async (event, newPage) => {
    history.push({
      pathname: location.pathname,
      search: `page=${newPage}`
    });
    dispatch(changePage(newPage));
  };

  const handleTabChange = tabName => {
    if (tabName === 0) {
      history.push('/warehouse');
    }
  };

  const tabContents = [
    <>null</>,
    <SitesTabContent
      paginatedWarehousesWithAppliances={paginatedWarehousesWithAppliances}
      handleSitesDrawerMenuOpen={handleSitesDrawerMenuOpen}
      setSelectedSite={setSelectedSite}
      handlePageChange={handleSitePageChange}
      isLoading={sitesLoading}
      page={page}
      pages={sitePages}
    />
  ];

  const SectionWrapper = !isFilterSelected && !loading ? NoFilterData : Root;

  return (
    <SectionWrapper as="section">
      <FilterButtonContainerSiteManager>
        <FilterWrapper data={warehouseFilterConfig} />
      </FilterButtonContainerSiteManager>
      {sitesLoading ? (
        <PreloaderComponent />
      ) : (
        <>
          <TabsSpacing style={loading ? { display: 'none' } : {}}>
            <MobileTabs
              labels={tabLabels}
              contents={tabContents}
              setMobileChosenTab={handleTabChange}
              defaultChosenTab={1}
            />
          </TabsSpacing>
          <MobileDrawerMenu
            isOpen={isSitesDrawerMenuOpen}
            onClose={handleSitesDrawerMenuClose}
            menuTitle={selectedSite?.label}
            menuItems={emptySitesMenuItems}
          />
          <DeleteWarehouseDialog
            open={isDeleteSiteModalOpen}
            dialogTitle={`Do you want to delete the "${selectedSite?.label ?? ''}"?`}
            entityTitle={selectedSite?.label ?? ''}
            dialogContentText="Type the site label to confirm"
            textFieldLabel="Label"
            onClose={handleDeleteSiteModalClose}
            onDelete={handleDeleteSite}
          />
          {userType < 10 &&
            <MobileDoubleButtons
              firstLabel="Add site"
              secondLabel="Add application"
              firstAddress="/create-warehouse"
              secondAddress="/warehouse/appliance/create"
            />}
        </>
      )}
    </SectionWrapper>
  );
};

export default SitesMobileView;
